export enum SwapUnassignPointReason {
  ORDER = 'order',
  POINT = 'point',
  SEMI_TRAILER = 'semi-trailer',
}
